import { FC } from 'react'
import { Img } from 'components/basic/Img'
import styles from './FeaturedQuote.module.scss'

export const FeaturedQuote: FC = () => {
	return (
		<>
			<div className={`max-1440 ${styles.container}`}>
				<div className={styles.img_container}>
					<Img
						src={'https://eightsleep.imgix.net/featured_quote_mobile.jpg?v=1690454492'}
						alt={'Portrait of Danny Green'}
						sources={[
							{
								mediaQuery: '(max-width: 599px)',
								src: 'https://eightsleep.imgix.net/featured_quote_mobile.jpg?v=1690454492',
							},
							{
								mediaQuery: '(min-width: 600px)',
								src: 'https://eightsleep.imgix.net/featured_quote_desktop.jpg?v=1690454493',
							},
						]}
						lazy={true}
					/>
				</div>
				<div className={styles.wrapper}>
					<p className={styles.quote}>
						‘’Eight Sleep’s approach to bed cooling allows for improved sleep quality and subsequently, improved recovery day-to-day. This is one of the most reliably beneficial technologies I’ve seen
						enter the market’’
					</p>
					<p className={styles.signature}>— Dr. Kevin Sprouse, EF Education-EasyPost, Performance Doctor</p>
				</div>
			</div>
		</>
	)
}
